import React from 'react'
import AppLayout from '../../layout/components/AppLayout'
import { Link } from 'react-router-dom'
import { List, SpeakerNotes } from '@mui/icons-material'


function ComplaintDashboardPage() {
  return (
    <AppLayout>
		<div className='container'>
		<div className='row mt-2'>
                <div className='col-md-12'>
                    <h3 className='mb-0 fw-bold text-center'>Complaint</h3>
                </div>
            </div>

            <div className='row'>
                <div className='col-md-3 col-6 my-3'>
                    <div className='card bg-light p-3 ' >
                        <Link to={"/complaint/form/1"} className='btn'   >
                        <h3> <i style={{fontSize:60}} className="fa-solid fa-dumpster"></i> </h3>
                            <p>Garbage pick up Request</p>
                        </Link>
                    </div>
                </div>

                <div className='col-md-3 col-6 my-3'>
                    <div className='card p-3 ' >
                        <Link to={"/complaint/form/14"} className='btn'   >
                            <h3> <i style={{fontSize:60}} className="fa-solid fa-timeline"></i> </h3>
                            <p>Sewerage Blocked</p>
                        </Link>
                    </div>
                </div>

                <div className='col-md-3 col-6 my-3'>
                    <div className='card bg-light p-3 ' >
                        <Link to={"/complaint/form/25"} className='btn'   >
                            <h3> <i style={{fontSize:60}} className="fa-solid fa-shield-dog"></i> </h3>
                            <p>Stray Dogs</p>
                        </Link>
                    </div>
                </div>

                <div className='col-md-3 col-6 my-3'>
                    <div className='card p-3 ' >
                        <Link to={"/complaint/form/8"} className='btn'   >
                            <h3> <i style={{fontSize:60}} className="fa-solid fa-paw"></i> </h3>
                            <p>Dead Animal</p>
                        </Link>
                    </div>
                </div>
                
                <div className='col-md-6 my-3'>
                    <div className='card bg-dark p-3 ' >
                        <Link to={"/complaint/form"} className='btn text-white'   >
                            <h3><SpeakerNotes style={{fontSize:60}} /></h3>
                            <p>Book My Complaint</p>
                        </Link>
                    </div>
                </div>

                <div className='col-md-6 my-3'>
                    <div className='card bg-success p-3 ' >
                        <Link to={"/complaint/list"} className='btn text-white'   >
                            <h3><List style={{fontSize:60}} /></h3>
                            <p>My Complaint List</p>
                        </Link>
                    </div>
                </div>
            </div>
		</div>
      
    </AppLayout>
  )
}

export default ComplaintDashboardPage